import React from 'react'
import Reflux from 'reflux-react-16'

import {Route} from 'react-router-dom'

import LoginStore from '../../stores/LoginStore.js'
import LoginActions from '../../actions/LoginActions.js'
import {sanitizeRedirect} from '../../utils/redirect.js'

import {Colors, Popup, Stack} from '../../components/UI/index.js'
import AppNav, {layoutStyle, layoutContentStyle} from '../../components/navigation/AppNav.js'
import {adminNavigation} from '../../components/navigation/adminNavigation.js'
import {getNavPosition, subscribeNavPosition} from '../../components/navigation/navPosition.js'
import LoginPopup from '../../components/login/LoginPopup.js'
import {openMfaPopup} from '../../components/login/mfaPopup.js'
import showTwoFactorWarning from '../../components/login/twoFactorWarning.js'
import Dashboard from './Dashboard.js'
import Resellers from './Resellers.js'
import Invoices from './Invoices.js'
import Customers from './Customers.js'
import SearchOrdersAndParcels from './SearchOrdersAndParcels.js'
import Logs from './Logs.js'

export default class Layout extends Reflux.Component {
    constructor(props) {
        super(props)

        this.store = LoginStore
    }

    componentDidMount() {
        const {history} = this.props

        document.title = 'Admin'

        LoginActions.loggedIn((loggedIn, link) => {
            if (!loggedIn) {
                const redirect = sanitizeRedirect(`${history.location.pathname}${history.location.search}`)

                if (redirect) {
                    history.push(`/login?redirect=${encodeURIComponent(redirect)}`)
                } else {
                    history.push('/login')
                }
            } else {
                const originalPathname = `${history.location.pathname}${history.location.search}`
                history.push(link)
                if (originalPathname === '/admin' || originalPathname === '/admin/') {
                    history.push('/admin/resellers')
                } else if (originalPathname.includes('/admin')) {
                    history.push(originalPathname)
                }
            }
        })

        this.unsubscribeNavPosition = subscribeNavPosition(() => this.setState({navPosition: getNavPosition()}))
    }

    componentWillUnmount() {
        super.componentWillUnmount()
        this.unsubscribeNavPosition?.()
    }

    onClickSwitchAccount() {
        const {accounts, user} = this.state

        this.loginPopup.open(accounts, user, (index) => {
            const account = accounts[index]

            if ((account.mfaRequired && !user.is2FASignedIn)) {
                if (account.mfaEnabled) {
                    if (account.mfaMethod === 'email') {
                        LoginActions.mailMFACode(null, index, null, (err) => {
                            if (err) {
                                this.popup.setError(err)
                            }
                        })
                    }

                    openMfaPopup(this.popup, {
                        mfaMethod: account.mfaMethod,
                        onLogin: (code) => {
                            LoginActions.switchAccount(index, code, (err) => {
                                if (err) {
                                    this.popup.setError(err)
                                }
                            })
                        }
                    })
                } else {
                    showTwoFactorWarning(this.popup, () => LoginActions.logout())
                }
            } else {
                LoginActions.switchAccount(index, null, (err, reseller) => {
                    if (err) {
                        this.setState({loading: false, error: err})

                        if ((!account.isMessenger && reseller.settings.mfaWebEnabled) || (account.isMessenger && reseller.settings.mfaAppEnabled)) {
                            showTwoFactorWarning(this.popup, () => LoginActions.logout())
                        }
                    }
                })
            }
        })
    }

    onClickLogout() {
        this.popup.open('Uitloggen', 'Weet je zeker dat je wilt uitloggen?', () => LoginActions.logout())
    }

    render() {
        const {user, accounts} = this.state
        const {history} = this.props
        const {pathname} = history.location

        const navigation = adminNavigation({
            user,
            accounts,
            pathname,
            onClickSwitchAccount: this.onClickSwitchAccount.bind(this),
            onClickLogout: this.onClickLogout.bind(this)
        })

        const navPosition = getNavPosition()

        return (
            <Stack style={{flex: 1, height: '100vh', minWidth: 1366, ...layoutStyle(navPosition)}}>
                {/* No reseller branding: the Veloyd logo and colour */}
                <AppNav navigation={navigation} position={navPosition} branding={{}} history={history} />

                <Stack style={{flex: 1, background: Colors.backgroundNeutral, ...layoutContentStyle(navPosition)}}>
                    <Route path='/admin/notificaties' render={() => <Dashboard user={user} />} />
                    <Route path='/admin/resellers' render={() => <Resellers user={user} history={history} />} />
                    <Route path='/admin/klanten' render={() => <Customers user={user} history={history} />} />
                    <Route path='/admin/zoeken' render={() => <SearchOrdersAndParcels user={user} history={history} />} />
                    <Route path='/admin/facturen' render={() => <Invoices user={user} />} />
                    <Route path='/admin/logs' render={() => <Logs user={user} history={history} />} />
                </Stack>

                <LoginPopup ref={(ref) => this.loginPopup = ref} />
                <Popup ref={(ref) => this.popup = ref} />
            </Stack>
        )
    }
}
